<template>
  <div id="app">
    <audio id="notionAudio" src="/static/audio/notionAudio.mp3" style="display:none;"></audio>
    <router-view style="width: 100%;min-width: 1440px;overflow-x: auto;"/>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>



// WEBPACK FOOTER //
// src/App.vue